import { render } from "./WhatsappConfigurations.vue?vue&type=template&id=9facaed0&scoped=true"
import script from "./WhatsappConfigurations.vue?vue&type=script&lang=js"
export * from "./WhatsappConfigurations.vue?vue&type=script&lang=js"

import "./WhatsappConfigurations.vue?vue&type=style&index=0&id=9facaed0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9facaed0"]])

export default __exports__